<template>
  <div v-if="dialogVisible" class="radish-right" :style="{ 'z-index': zIndex }">
    <div class="radish-head">
      <div class="radish-title">填写手机</div>
      <div class="radish-btns"><el-button size="mini" icon="el-icon-close" circle @click="close"></el-button></div>
    </div>
    <div style="padding: 50px 15px;">
      <el-alert v-if="msg" :title="msg" type="warning" :closable="false"> </el-alert>
      <el-form :inline="true">
        <el-form-item label="姓名">
          <el-input v-model="name" size="mini" disabled></el-input>
        </el-form-item>
        <el-form-item label="手机">
          <div style="display:flex;">
            <el-select v-model="country" size="mini" filterable placeholder="+86" style="width:120px">
              <el-option
                v-for="(code, key) in countryCodes"
                :key="key"
                :label="`+${code.code}(${code.cnName})`"
                :value="code.shortName">
              </el-option>
            </el-select>
            <el-input v-model="phone" size="mini" placeholder="请输入手机"></el-input>
          </div>
        </el-form-item>
      </el-form>
      <div style="padding:10px;"> 
        <el-button type="primary" size="mini" @click="confirm">确定</el-button>
        <el-button size="mini" @click="close">暂不填写</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { countryCodes } from '../constant/common-methods'
export default {
  props: {
    handleFill: { type: Function, default: () => {} },
  },
  data: function() {
    return {
      dialogVisible: false,
      phone: '',
      name: '',
      msg: '',
      rid: '',
      countryCodes,
      country: '',
      zIndex: 1004,
    }
  },
  methods: {
    show: function(msg, defaults) {
      this.zIndex = app.root.dragindex++
      this.phone = ''
      this.name = ''
      this.country = ''
      this.msg = msg || ''
      if (defaults) {
        const { name, phone, rid } = defaults
        this.phone = phone
        this.name = name
        this.rid = rid
      }
      this.dialogVisible = true
    },
    confirm: async function() {
      if (!this.phone) {
        this.msg = '请填写手机'
        return false
      }
      try {
        const countryObj = this.countryCodes.find(c => c.shortName === this.country)
        const phone = (!this.country || this.country === 'CN') ? this.phone : `${countryObj?countryObj.code:''}${this.phone}`
        const dup = await app.service('radish').duplicate({ phone: phone })
        if (dup.msg === 'duplicate') {
          this.$confirm(`该手机号有重复人选【${dup.data.姓名}-${dup.data.公司}】，是否要合并`, '合并人选', {
            distinguishCancelAndClose: true,
            confirmButtonText: '是，合并',
            cancelButtonText: '否，重新填写手机'
          })
          .then(async () => {
            const res = await app.service('radish').mergeTwo({ oldId: this.rid, newData: { _id: dup.data.id} })
            if (res.status == 'success') {
              this.dialogVisible = false
              const ref = window.app.root.$refs.cvPreview
              ref.close()
              this.handleFill(dup.data.id)
            } else {
              this.$message.error(res.msg)
            }
          })
          .catch(action => {
            this.phone = ''
          })
        } else {
          let res = await app.service('radish').modifyById({ _id: this.rid, data: { 手机: phone } })
          if (res.status === 'success') {
            this.close()
          } else {
            this.$message.error(res.msg)
          }
        }
      } catch (e) {
        this.$message.error(e)
      }
    },
    close() {
      this.dialogVisible = false
      const ref = window.app.root.$refs.cvPreview
      ref.close()
      this.handleFill(this.rid)
    }
  },
}
</script>
